module.exports = __webpack_public_path__ + "static/img/honor10.164ff7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor10.png
// module id = eqb5
// module chunks = 0